// extracted by mini-css-extract-plugin
export default {"Item":"Item_Item__4nSaZ","Header":"Item_Header__YESnl","Text":"Item_Text__s6S1-","Button":"Item_Button__+KxIo"};